import Card from "Components/Common/Card/Card";
import CardContent from "Components/Common/Card/CardContent/CardContent";
import CardImage from "Components/Common/Card/CardImage/CardImage";
import RouterLink from "Components/RouterLink/RouterLink";
import { RouterLinkType } from "Enums/RouterLinkType";
import { AuditTemplate } from "Models/Audits/AuditTemplate";
import * as React from "react";
import AuditTemplateBlockDetailsBlock from "./AuditTemplateBlockDetailsBlock/AuditTemplateBlockDetailsBlock";

interface IProps {
    auditTemplate: AuditTemplate;
}

const AuditTemplateBlockCard: React.FunctionComponent<IProps> = (props: IProps) => (
    <RouterLink to={`/audittemplates/${props.auditTemplate.id}`} type={RouterLinkType.default}>
        <Card>
            <CardImage src={props.auditTemplate.pictureUrl} />
            <CardContent>
                <AuditTemplateBlockDetailsBlock auditTemplate={props.auditTemplate} />
            </CardContent>
        </Card>
    </RouterLink>
);

export default AuditTemplateBlockCard;


// WEBPACK FOOTER //
// ./src/Components/Pages/AuditTemplateBlockOverview/AuditTemplateBlockView/AuditTemplateBlockCard/AuditTemplateBlockCard.tsx